import React, { useMemo } from "react";
import { ReferenceInput } from "react-admin";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import bg from "date-fns/locale/bg";
import { subMonths } from "date-fns";
import { administrationRequests } from "api/administrationApi";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";

// Structural unit is optional - when empty, the report is generated for all structural units.
const HealthInsurance = ({ handleParamChange }) => {
  const lastMonth = useMemo(() => {
    const value = subMonths(new Date(), 1);

    handleParamChange("month", value.getMonth() + 1);
    handleParamChange("year", value.getFullYear());

    return value;
  }, [handleParamChange]);

  return (
    <>
      <ReferenceInput
        reference={administrationRequests.getStructuralUnitsSelect()}
        source="structuralUnitId"
        filter={{ filterByUser: true }}
      >
        <AutoPickSelectInput
          source="structuralUnitId"
          label="Структурна единица"
          optionText="name"
          emptyText="Всички"
          onValueChange={value => handleParamChange("structuralUnitId", value)}
          helperText={false}
        />
      </ReferenceInput>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={bg}
      >
        <DatePicker
          label="Месец"
          views={["year", "month"]}
          openTo="month"
          defaultValue={lastMonth}
          maxDate={lastMonth}
          onChange={val => {
            handleParamChange("month", val.getMonth() + 1);
            handleParamChange("year", val.getFullYear());
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default HealthInsurance;
